import { createContext, useContext } from 'react';
import { createStore, useStore } from 'zustand';

type KalenderScrollState = {
  isScrolling: boolean;
  setIsScrolling: (isScrolling: boolean) => void;
};

export const createKalenderScrollStore = () =>
  createStore<KalenderScrollState>((set) => ({
    isScrolling: false,
    setIsScrolling: (isScrolling) => set({ isScrolling }),
  }));

export type KalenderScrollStore = ReturnType<typeof createKalenderScrollStore>;

export const KalenderScrollContext = createContext<KalenderScrollStore | null>(
  null,
);

// Isolated subscription so only components reading isScrolling re-render,
// keeping the calendar grid off the per-scroll-frame render path.
export function useIsScrolling(): boolean {
  const store = useContext(KalenderScrollContext);
  if (!store) {
    throw new Error(
      'useIsScrolling must be used within a KalenderScrollContext provider',
    );
  }
  return useStore(store, (state) => state.isScrolling);
}
